import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
    TimeSelectorContainer,
    TimeSelectorField,
    TimeSelectorLabel,
    TimeSelectorSelect,
    TimeSelectorIcon,
} from './TimeSelector.style';
import { ChevronIcon } from '../../../Icons/ChevronIcon';
import { HOURS, MINUTE_SLOTS } from './constants';

export const TimeSelector = ({ hours, minutes, minimumHour, minimumMinute, onHoursChange, onMinutesChange }) => {
    const { t } = useTranslation();

    const [isHoursFocused, setIsHoursFocused] = useState(false);
    const [isMinutesFocused, setIsMinutesFocused] = useState(false);

    const handleHoursChange = (e) => {
        onHoursChange(e.target.value);
    };

    const handleMinutesChange = (e) => {
        onMinutesChange(e.target.value);
    };

    return (
        <TimeSelectorContainer>
            <TimeSelectorField position="left" isActive={isHoursFocused} data-testid="hours-selector">
                <TimeSelectorLabel isActive={isHoursFocused} className={'odf-text-sm'}>
                    {t('searchByHour.timeSelector.hours.label')}
                </TimeSelectorLabel>
                <TimeSelectorSelect
                    value={hours}
                    onChange={handleHoursChange}
                    onFocus={() => setIsHoursFocused(true)}
                    onBlur={() => setIsHoursFocused(false)}
                    data-testid="hours-select"
                >
                    {HOURS.map((hour) => (
                        <option
                            key={hour}
                            value={hour}
                            disabled={parseInt(hour, 10) < parseInt(minimumHour, 10)}
                        >
                            {hour}
                        </option>
                    ))}
                </TimeSelectorSelect>
                <TimeSelectorIcon>
                    <ChevronIcon size={16} />
                </TimeSelectorIcon>
            </TimeSelectorField>

            <TimeSelectorField position="right" isActive={isMinutesFocused} data-testid="minutes-selector">
                <TimeSelectorLabel isActive={isHoursFocused} className={'odf-text-sm'}>
                    {t('searchByHour.timeSelector.minutes.label')}
                </TimeSelectorLabel>
                <TimeSelectorSelect
                    value={minutes}
                    onChange={handleMinutesChange}
                    onFocus={() => setIsMinutesFocused(true)}
                    onBlur={() => setIsMinutesFocused(false)}
                    data-testid="minutes-select"
                >
                    {MINUTE_SLOTS.map((minute) => (
                        <option
                            key={minute}
                            value={minute}
                            disabled={parseInt(minute, 10) < parseInt(minimumMinute, 10)}
                        >
                            {minute}
                        </option>
                    ))}
                </TimeSelectorSelect>
                <TimeSelectorIcon>
                    <ChevronIcon size={16} />
                </TimeSelectorIcon>
            </TimeSelectorField>
        </TimeSelectorContainer>
    );
};

TimeSelector.propTypes = {
    hours: PropTypes.string.isRequired,
    minutes: PropTypes.string.isRequired,
    minimumHour: PropTypes.string.isRequired,
    minimumMinute: PropTypes.string.isRequired,
    onHoursChange: PropTypes.func.isRequired,
    onMinutesChange: PropTypes.func.isRequired,
};
